export const alerce = {
  primary: "#045ae3",
  secondary: "#03a9f4",
  accent: "#3f51b5",
  error: "#f44336",
  warning: "#ffc107",
  info: "#00bcd4",
  success: "#4caf50"
};

export const xpo = {
  primary: "#858585",
  secondary: "#f44336",
  accent: "#f44336",
  error: "#f44336",
  warning: "#ffeb3b",
  info: "#2196f3",
  success: "#8bc34a"
};

export default alerce;
